module.exports = __webpack_public_path__ + "img/CS_3_Section_5_digger-01.c91b8d0c.png";